// Bublina ⓘ s Omnibus minimem (nejnižší cena za posledních 30 dní).
//
// Otevírání a zavírání je tady, ne v bloku, protože bublinu mají DVĚ místa: cena sestavy
// (blocks/premium-bundle.liquid) a samostatná cena produktu (blocks/pp-price.liquid). Dokud to
// žilo ve skriptu sestavy, u samostatné ceny by ⓘ nešlo rozkliknout - skript sestavy se
// nespustí, když se sestava nevykreslí. Naplnění hodnoty do bubliny si každý blok řeší sám,
// tohle je jen chování.
//
// Na ukazovateli otevírá hover (CSS), na dotyku hover neexistuje, takže tap přepíná. Vázáno na
// dokument, ne na jednotlivé tlačítko, protože cenový řádek se při přepnutí volby překresluje.
// Escape i klik mimo zavírají.
(function () {
  if (window.__omnibusTipInit) return;
  window.__omnibusTipInit = true;

  function closeAll(except) {
    document.querySelectorAll('[data-omni].is-open').forEach(function (o) {
      if (except && o === except) return;
      o.classList.remove('is-open');
      var b = o.querySelector('[data-omni-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-omni-btn]');
    var omni = btn ? btn.closest('[data-omni]') : null;
    if (omni) {
      var open = omni.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      closeAll(omni);
      return;
    }
    document.querySelectorAll('[data-omni].is-open').forEach(function (o) {
      if (o.contains(e.target)) return;
      o.classList.remove('is-open');
      var b = o.querySelector('[data-omni-btn]');
      if (b) b.setAttribute('aria-expanded', 'false');
    });
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });
})();
